module.exports = __webpack_public_path__ + "img/img-free-job-posting.a082f6d1.png";